import { Avatar, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { EnrollmentModel } from "services/organizationPortalClient";

enum EnrollmentStatus {
  Enrolled = "Enrolled",
  InProgress = "In Progress",
}

export default function EnrollmentStatusIcon({
  value,
}: {
  value: EnrollmentModel;
}) {
  const theme = useTheme();
  const isEnrolled = value.status === EnrollmentStatus.Enrolled;
  const StatusIcon = isEnrolled ? HowToRegIcon : HourglassEmptyIcon;
  const color = isEnrolled
    ? theme.palette.primary.main
    : theme.palette.success.main;

  return (
    <Tooltip title={value.status}>
      <Avatar sx={{ bgcolor: alpha(color, 0.12), color, width: 34, height: 34 }}>
        <StatusIcon fontSize="small" />
      </Avatar>
    </Tooltip>
  );
}
